console.log('custom.js loaded');

const replaceWishlistIcon = () => {
  const wishlistBtn = document.querySelector('.xb-wishlist-header-auto');
  if (!wishlistBtn) return;

  const svgWrapper = wishlistBtn.querySelector('.xb-wishlist-header-auto__svg');
  if (!svgWrapper) return;

  // Stop once replaced
  if (svgWrapper.classList.contains('icon-replaced')) return;

  svgWrapper.innerHTML = `
    <svg width="20" height="40" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
      2 6 4 4 6.5 4c1.74 0 3.41 1.01 4.13 2.44
      C11.09 5.01 12.76 4 14.5 4
      17 4 19 6 19 8.5
      c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
  `;

  svgWrapper.classList.add('icon-replaced');
};

// Run immediately
replaceWishlistIcon();

// Observe late-loaded content (XB Wishlist fix)
const observer = new MutationObserver(replaceWishlistIcon);
observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.faq-question');
  if (!btn) return;

  btn.parentElement.classList.toggle('active');
});
document.addEventListener('DOMContentLoaded', function () {
  var mq = window.matchMedia('(min-width: 200px) and (max-width: 600px)');

  function applySonCenter() {
    var son = document.querySelector('p.son');
    if (!son) return;
    var wrapper = son.parentElement;

    if (mq.matches) {
      son.style.display = 'inline-block';
      son.style.width = 'auto';
      if (wrapper) {
        wrapper.style.textAlign = 'center';
        wrapper.style.display = 'block';
        wrapper.style.margin = '0 auto';
      }
    } else {
      son.style.display = '';
      son.style.width = '';
      if (wrapper) {
        wrapper.style.textAlign = '';
        wrapper.style.display = '';
        wrapper.style.margin = '';
      }
    }
  }

  applySonCenter();
  mq.addEventListener('change', applySonCenter);

  // re-apply after Shopify re-renders the pill on variant change
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects, .product-form__input')) {
      setTimeout(applySonCenter, 300);
    }
  });
});
